// tslint:disable: jsx-key
import React from 'react';
import { Modal } from '../Modal';
import { Body3 } from '../../typography';
import { ButtonBlockColumn } from './../../sharedStyledComponents/GenericStyles.styled';
import { ButtonLarge } from '../buttons/ButtonLarge';
import { Trans, useTranslation } from 'react-i18next';
import { ISwitchHotelModal } from '../../../../app/@types/switchHotelModal';
import { MY_ACTION_LABELS_LOWER_CASE } from '../../../../enums/MyActions';
import styled from 'styled-components';

export const TitleContainer = styled.div`
  text-align: center;
  padding: 0 ${({ theme }) => theme.fontSize.xxl};
`;

export function SwitchHotelModal ({
  showSwitchHotelModal,
  handleModalClose,
  switchHotelHandler,
  notificationHotelData,
}: ISwitchHotelModal) {
  const { t } = useTranslation();

  const actionType =
    MY_ACTION_LABELS_LOWER_CASE[notificationHotelData.type] ||
    notificationHotelData.type;

  const hotelName = notificationHotelData.switchHotel;

  return (
    <>
      <Modal
        data-testid="modal"
        isOpen={showSwitchHotelModal}
        handleModalClose={handleModalClose}
      >
        <ButtonBlockColumn>
          <TitleContainer>
            <Body3 data-testid="modal-title">
              <Trans
                i18nKey="COMMON.NOTIFICATION.SWITCH_HOTEL_MESSAGE"
                values={{ actionType, hotelName }}
                components={[<strong />]}
              />
            </Body3>
          </TitleContainer>
          <ButtonLarge
            title={t('COMMON.NOTIFICATION.PROCEED')}
            onClick={() =>
              switchHotelHandler(
                notificationHotelData.hotelId,
                notificationHotelData.url,
                notificationHotelData.notificationId
              )
            }
            backgroundColor="oxfordBlue"
            data-testid="modal-proceed-button"
          />

          <ButtonLarge
            title={t('COMMON.NOTIFICATION.CANCEL')}
            onClick={() => handleModalClose()}
            outlined={true}
            inverted={true}
            data-testid="modal-cancel-button"
          />
        </ButtonBlockColumn>
      </Modal>
    </>
  );
}
